import { UpperCasePipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-claim-detail-date-display',
  templateUrl: './claim-detail-date-display.component.html',
  styleUrls: ['./claim-detail-date-display.component.scss'],
  standalone: true,
  imports: [
    UpperCasePipe
  ]
})
export class ClaimDetailDateDisplayComponent implements OnChanges {

  @Input() month!: string;
  @Input() day!: string;
  @Input() detail!: string;

  @Input() date?: string;

  ngOnChanges(_: SimpleChanges): void {
    if(!this.date) {
      return;
    }

    this.day = moment(this.date).utc().format('D');
    this.month = moment(this.date).utc().format('MMM');
  }
}